export function partition<T>(arr: T[], parts: number): T[][] {
  const result = [] as T[][];

  for (let i = 0; i < arr.length; i += parts) {
    const intermediate = [] as T[];

    for (let e = 0; e < parts; e++) {
      const idx = i + e;
      const value = arr[idx];

      if (value !== undefined) {
        intermediate.push(arr[idx]);
      }
    }

    result.push(intermediate);
  }

  return result;
}
